import {observer} from "mobx-react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";

import FilterButton from "@dropDesk/presentation/components/filters/filter_button";
import ButtonNew from "@dropDesk/presentation/components/buttons/button_new";
import React, {useRef, useState} from "react";
import SelectSearchClient from "@dropDesk/presentation/components/inputs/select_search_clients";
import {
    Body,
    Container, Footer,
    PaddingFilters
} from "@dropDesk/presentation/pages/client/ui/contacts/search/search_bar/filters/styled";
import {ClientEntity} from "@dropDesk/domain/entities/client/client.entity";

const Filters = observer(
    ({
         clientFilter,
         setClientFilter,
         loading,
         onSearch,
     }: {
        clientFilter: ClientEntity | null,
        setClientFilter: (clientFilter: ClientEntity | null) => void
        onSearch: (searchParam?: string) => void,
        loading: boolean,
    }) => {

        const [visible, setVisible] = useState<boolean>(false);
        const [zIndex, setZIndex] = useState<number>(0);
        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;
        const timeoutRef = useRef<number | undefined>(undefined);

        const handleClickChange = (open: boolean) => {
            if (open) {
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }
                setZIndex(1300);
            } else {
                timeoutRef.current = window.setTimeout(() => {
                    setZIndex(0);
                }, 200);
            }
            setVisible(open);
        };

        return (
            <FilterButton
                hasFilter={!!clientFilter}
                filterCount={clientFilter ? 1 : 0}
                loading={loading}
                open={visible}
                onOpenChange={handleClickChange}
                zIndex={zIndex}
                content={
                    <Container border={colors.border}>
                        <Body>
                            <PaddingFilters>
                                <SelectSearchClient
                                    size={37}
                                    useRemoveFilter={!!clientFilter}
                                    label={'Empresa'}
                                    placeHolder={"Selecione a empresa"}
                                    handleSelectClient={(value, client) => {
                                        setClientFilter(client ?? null);
                                        onSearch();
                                    }}
                                    value={clientFilter ? {
                                        value: clientFilter.id,
                                        label: !!clientFilter.socialName ? clientFilter.socialName : clientFilter.name,
                                    } : undefined}
                                    width={400}
                                    disabled={loading}
                                />
                            </PaddingFilters>
                        </Body>
                        <Footer>
                            <ButtonNew
                                label={'limpar filtros'}
                                onClick={() => {
                                    setClientFilter(null);
                                    onSearch();
                                    setVisible(false);
                                }}
                                useIcon={false}
                                sizeLeftIcon={15}
                                disabled={loading}
                                radius={25}
                            />
                        </Footer>
                    </Container>
                }/>

        )
    })
export default Filters;
